// How many words Fill the gaps hides in a sentence, learnt per sentence (as in
// the iPhone and TV apps): none (read it out) → a third → half → all of them.
// Said in full without help moves it up a step; "Not yet" moves it down; with
// help it stays. From memory always hides everything and doesn't change it.
// Kept in this browser.

const SHARES = [0, 0.34, 0.5, 1]
export const LEVEL_NAMES = ['None', 'Some', 'Half', 'All']
// A sentence not met before starts with a third of it hidden.
const FIRST = 1
const clamp = (n) => Math.min(Math.max(n, 0), SHARES.length - 1)
const key = (text, lang) => `sayLevel.${lang}.${String(text || '').trim().toLowerCase()}`

export function sayLevel(text, lang) {
  try {
    const v = localStorage.getItem(key(text, lang))
    const n = v == null ? NaN : parseInt(v, 10)
    return Number.isFinite(n) ? clamp(n) : FIRST
  } catch { return FIRST }
}

/** outcome: 'clean' | 'nearly' (said, no help) · 'helped' · 'missed' */
export function recordSayLevel(outcome, text, lang) {
  const now = sayLevel(text, lang)
  const next = outcome === 'clean' || outcome === 'nearly' ? now + 1 : outcome === 'missed' ? now - 1 : now
  try { localStorage.setItem(key(text, lang), String(clamp(next))) } catch { /* private mode */ }
}

/** Which of the real words (their indexes) to hide at this level: spread out
 *  evenly from a random start, always one shown unless it's all of them. */
export function hiddenAt(real, level) {
  const share = SHARES[clamp(level)]
  if (!share || !real.length) return new Set()
  if (share >= 1 || real.length === 1) return new Set(real)
  const count = Math.min(Math.max(1, Math.round(real.length * share)), real.length - 1)
  const step = real.length / count
  const offset = Math.random() * step
  const out = new Set()
  for (let k = 0; k < count; k++) out.add(real[Math.min(real.length - 1, Math.floor(offset + k * step))])
  return out
}
